module.exports = __webpack_public_path__ + "static/media/map-pin-pending.44b37b35.svg";